var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Subscription from "./baseSubscription";
/**
 * @class EmitterSubscription
 * Extends base subscription to add listener and context properties.
 */
var EmitterSubscription = /** @class */ (function (_super) {
    __extends(EmitterSubscription, _super);
    /**
     * @param {SubscriberRegistry} subscriber - The subscriber that controls
     *   this subscription
     * @param {function} listener - Function to invoke when the specified event is
     *   emitted
     * @param {*} context - Optional context object to use when invoking the
     *   listener
     */
    function EmitterSubscription(subscriber, listener, context) {
        var _this = _super.call(this, subscriber) || this;
        _this.listener = listener;
        _this.context = context;
        return _this;
    }
    return EmitterSubscription;
}(Subscription));
export default EmitterSubscription;
//# sourceMappingURL=emitterSubscription.js.map